import { FundOfferBaseEntity } from '@genial/services';
import { FundOrderBuyEntity } from '@genial/services/src';
import { Utils } from '@genial/utils';

import { RiskRating } from '../../../../../../../../components/RiskRating';
import { notificationChannelsData } from '../../../../../../../Resume/utils';
import { TicketApplicationBaseInfoProps } from '../../components/TicketApplicationSuccessDetails';

export const getFundsSuccessInfos = (
  offer: FundOfferBaseEntity,
  order: FundOrderBuyEntity,
  showSendingChannels: boolean,
  hideDateTimeFieldsOnProverOrigin: boolean
): TicketApplicationBaseInfoProps => {
  const orderHash = order.orderHash || order.orderId || '--';
  const orderName = order.orderName;

  const orderNameFormatted = orderName && orderHash ? `${orderName} - ${orderHash}` : '--';

  const orderChannels = notificationChannelsData({ order });

  const hasOrderOrigin = !!order?.interactionChannelAuditDetail as boolean;

  const productDetails = [
    { label: 'Produto', value: offer.productDisplay || '--' },
    { label: 'Tipo', value: offer.productCategory || '--' },
    {
      label: 'Rentabilidade 12 meses',
      value: Utils.Mask.Percentage(offer.profitabilityTwelveMonthsAdjusted),
    },
    { label: 'Taxa administrativa', value: offer.administrationFee || '--' },
    { label: 'Resgate', value: offer.redemptionDescription || '--' },
    {
      label: 'Perfil de risco',
      value: (
        <RiskRating
          currentRiskRating={Number(offer.riskRatingLevel) || 0}
          tooltip={offer.riskRating || ''}
        />
      ),
    },
    { label: 'Valor aplicado', value: Utils.Mask.Money(order.orderAmount) },
  ];

  const solicitationDate = order.interactionChannelAuditDetail?.interactionChannelDate;

  const channelDetails = [
    {
      label: 'Canal de solicitação',
      value: order.interactionChannelAuditDetail?.interactionChannelOption.channel || '--',
    },
  ];

  if (!hideDateTimeFieldsOnProverOrigin) {
    channelDetails.push(
      {
        label: 'Data de solicitação',
        value: solicitationDate ? Utils.Mask.DateFormat(solicitationDate, 'dd/MM/yyyy') : '',
      },
      {
        label: 'Horário de solicitação',
        value: solicitationDate ? Utils.Mask.DateFormat(solicitationDate, 'HH:mm') : '',
      }
    );
  }

  const orderDetails = [
    { label: 'Nome da ordem', value: orderNameFormatted },
    ...(hasOrderOrigin ? channelDetails : []),
  ];

  if (showSendingChannels) {
    orderDetails.push(
      { label: 'Canal de envio', value: orderChannels || '--' },
      {
        label: 'Hora/data de Envio',
        value: order.orderCreatedAt
          ? Utils.Mask.DateFormat(order.orderCreatedAt, 'dd/MM/yyyy HH:mm:ss')
          : '--',
      }
    );
  }

  return {
    orderHash,
    productDetails,
    orderDetails,
  };
};
